module.exports = __webpack_public_path__ + "img/65cae0201941565f5638edcfdf2d06e0.svg";